"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConversationFindById = exports.getAddMessageToConversation = exports.getConversationCreate = exports.getEditMessageInConversation = exports.getRemoveMessageFromConversation = void 0;
const ConversationModel_1 = __importDefault(require("@opsbase/lib-data-model/models/ConversationModel"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
const RemoveMessageMutation = (0, graphql_tag_1.default) `
	mutation RemoveMessageMutation($id: String!, $patch: JSON!) {
		removeMessageFromConversation(id: $id, patch: $patch) {
			id
			${ConversationModel_1.default.ALL_FIELDS}
		}
	}
`;
const getRemoveMessageFromConversation = (client) => {
    return ({ variables, update }) => client.mutate({ mutation: RemoveMessageMutation, variables, update });
};
exports.getRemoveMessageFromConversation = getRemoveMessageFromConversation;
const EditMessageMutation = (0, graphql_tag_1.default) `
	mutation editMessageInConversation($id: String!, $patch: JSON!) {
		editMessageInConversation(id: $id, patch: $patch) {
			id
			${ConversationModel_1.default.ALL_FIELDS}
		}
	}
`;
const getEditMessageInConversation = (client) => {
    return ({ variables, update }) => client.mutate({ mutation: EditMessageMutation, variables, update });
};
exports.getEditMessageInConversation = getEditMessageInConversation;
const CreateMessageMutation = (0, graphql_tag_1.default) `
	mutation CreateMessageMutation($patch: ConversationPatch!) {
		createConversation(patch: $patch) {
			id
			${ConversationModel_1.default.ALL_FIELDS}
		}
	}
`;
const getConversationCreate = (client) => {
    return ({ variables, update }) => client.mutate({ mutation: CreateMessageMutation, variables, update });
};
exports.getConversationCreate = getConversationCreate;
const AddMessageMutation = (0, graphql_tag_1.default) `
	mutation AddMessageMutation($id: String!, $patch: JSON!) {
		addMessageToConversation(id: $id, patch: $patch) {
			id
			${ConversationModel_1.default.ALL_FIELDS}
		}
	}
`;
const getAddMessageToConversation = (client) => {
    return ({ variables, update }) => client.mutate({ mutation: AddMessageMutation, variables, update });
};
exports.getAddMessageToConversation = getAddMessageToConversation;
const FindConversationQuery = (0, graphql_tag_1.default) `
query findConversationById($id: String!) {
    findConversationById(id: $id) {
        ${ConversationModel_1.default.ALL_FIELDS}
    }
}`;
const useConversationFindById = (client, conversationId, skip, customFindConversationQuery = FindConversationQuery) => {
    const variables = (0, react_1.useMemo)(() => ({ id: conversationId }), [conversationId]);
    const [data, setData] = (0, react_1.useState)({});
    const [force, setForce] = (0, react_1.useState)(false);
    const loading = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (!skip || force) {
            loading.current = true;
            client
                .query({ query: customFindConversationQuery, variables })
                .then(res => {
                setData(res === null || res === void 0 ? void 0 : res.data);
                setForce(false);
            })
                .catch(doNothing_1.default)
                .finally(() => (loading.current = false));
        }
    }, [client, customFindConversationQuery, force, skip, variables]);
    const refetch = (0, react_1.useCallback)(() => setForce(true), []);
    return (0, react_1.useMemo)(() => ({ data, refetch, loading: loading.current }), [data, refetch]);
};
exports.useConversationFindById = useConversationFindById;
